module.exports = __webpack_public_path__ + "static/media/bannerBlackoutHomeNormal.c6a52b83.png";